"use client"
import { useEffect } from "react"
import { usePageFeedback } from "./PageFeedbackContext"

type PageFeedbackOverrideProps = {
  show?: boolean | null
  pageHasActionBlock?: boolean | null
}

/**
 * Renders nothing; publishes the current page's `showFeedbackComponent` flag to
 * the layout-rendered FeedbackBar. Clearing on unmount means a client-side
 * navigation to a page that doesn't opt in hides the bar again.
 *
 * `pageHasActionBlock` lets the layout-rendered FeedbackBar reserve spacing
 * when the page renders its own action block, without the layout calling
 * headers() to resolve the current slug.
 */
export default function PageFeedbackOverride({
  show = false,
  pageHasActionBlock = false,
}: PageFeedbackOverrideProps) {
  const {
    setShowFeedback,
    clearShowFeedback,
    setPageHasActionBlock,
    clearPageHasActionBlock,
  } = usePageFeedback()

  useEffect(() => {
    setShowFeedback(Boolean(show))
    return () => {
      clearShowFeedback()
    }
  }, [show, setShowFeedback, clearShowFeedback])

  useEffect(() => {
    setPageHasActionBlock(Boolean(pageHasActionBlock))
    return () => {
      clearPageHasActionBlock()
    }
  }, [pageHasActionBlock, setPageHasActionBlock, clearPageHasActionBlock])

  return null
}
